import * as React from 'react';
import {
  Navigate,
  Outlet,
  useSearchParams,
} from 'react-router-dom';
import { useAuthStore } from '../../store';

const RedirectNavigator = () => {
  const { isAuthenticated } = useAuthStore();
  const [searchParams] = useSearchParams();

  const redirect = searchParams.get('redirect');
  // Route authenticated users to the redirect query param maintaining other query params
  if (isAuthenticated && redirect) {
    searchParams.delete('redirect');
    return <Navigate to={{ pathname: redirect, search: searchParams.toString() }} replace />;
  }
  return <Outlet />;
};

export default RedirectNavigator;
